/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerSms} from '../api'

export const useMutationRegisterSms = createReactQueryMutationHook('registerSms', registerSms)
